(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-search"]) return;
  try {
    
  class BlogOverview extends HTMLElement {
    constructor() {
      super();
      this.articles = this.querySelectorAll('[data-article]');
      this.topics = Array.from(
        new Set(
          Array.from(this.articles).map((article) => {
            return article.dataset.topic;
          })
        )
      );
      this.searchInput = this.querySelector('[data-search]');
      this.breadcrumbs = this.querySelector('[data-breadcrumbs]');
      this.setup();
      if (this.dataset.template == 'article') {
        this.showArticle(this.dataset.handle);
      }
      this.querySelector('[data-loading]').remove();
      this.querySelector('[data-main').classList.remove('opacity-0');
      if (this.topics.length > 0) {
        this.displayArticles(this.getArticlesByTopic(this.topics[0]), '');
        this.displayBreadcrumb(this.topics[0]);
        this.highlightTopic(this.topics[0]);
      }
    }

    setup() {
      this.addTopics();
      this.querySelectorAll('[data-reset]').forEach((el) => {
        el.addEventListener('click', () => this.reset());
      });
      const placeholder = superplaceholder({
        el: this.searchInput,
        sentences: this.topics.map((t) => `${t.slice(0, 20)}...`),
        options: {
          loop: true,
          letterDelay: 150,
        },
      });
      placeholder.start();

      this.searchInput.addEventListener('input', () => {
        this.handleSearch();
      });
    }

    showArticle(handle) {
      const topic = this.querySelector(`[data-article][data-handle="${handle}"]`).dataset.topic;
      const articles = this.getArticlesByTopic(topic);
      this.displayArticles(articles, handle);
      this.displayBreadcrumb(topic);
      this.highlightTopic(topic);
    }

    handleSearch() {
      const input = this.searchInput.value.toLowerCase().trim();
      switch (input) {
        case '':
          this.reset();
          break;
        default:
          this.search(input, this.searchInput.value);
          break;
      }
    }

    search(input, rawInput) {
      const matchedArticles = Array.from(this.articles).filter((article) => {
        return (
          article.dataset.topic.toLowerCase().includes(input) ||
          article.dataset.content.includes(input) ||
          article.dataset.title.toLowerCase().includes(input)
        );
      });
      this.displayBreadcrumb(rawInput);
      this.displayArticles(matchedArticles);
      this.highlightTopic(rawInput);
    }

    reset() {
      this.breadcrumbs.classList.add('hidden');
      this.hideBreadcrumbs();
      this.hideArticles();
      this.showTopics();
      if (this.topics.length > 0) {
        this.displayArticles(this.getArticlesByTopic(this.topics[0]), '');
        this.displayBreadcrumb(this.topics[0]);
        this.highlightTopic(this.topics[0]);
      }
    }

    getArticlesByTopic(topic) {
      return Array.from(this.articles).filter((article) => {
        return article.dataset.topic == topic;
      });
    }

    addTopics() {
      const container = this.querySelector('[data-topics]');
      this.topics.forEach((topic) => {
        const topicElement = document.createElement('h4');
        topicElement.dataset.show = topic;
        topicElement.textContent = topic;
        topicElement.classList.add('cursor-pointer', 'whitespace-nowrap', 'hover:underline');
        topicElement.addEventListener('click', () => {
          const articles = this.getArticlesByTopic(topic);
          this.displayArticles(articles);
          this.displayBreadcrumb(topic);
          this.highlightTopic(topic);
        });
        container.appendChild(topicElement);
      });
    }

    highlightTopic(topic) {
      this.querySelectorAll('[data-topics] h4').forEach((el) => {
        el.classList.remove('text-brand-dark-blue', 'underline');
        if (el.dataset.show === topic) {
          el.classList.add('text-brand-dark-blue', 'underline');
        }
      });
    }

    hideTopics() {
      this.querySelector('[data-topics-container]').classList.add('small-hide');
    }
    showTopics() {
      this.querySelector('[data-topics-container]').classList.remove('small-hide');
    }

    hideArticles() {
      this.querySelector('[data-articles]').classList.add('hidden');
    }

    hideBreadcrumbs() {
      this.breadcrumbs.classList.add('hidden');
    }

    displayBreadcrumb(topic) {
      this.breadcrumbs.classList.remove('hidden');
      this.querySelector('[data-breadcrumb]').textContent = topic;
    }

    displayArticles(articles, unfoldArticle) {
      this.hideTopics();
      const container = this.querySelector('[data-articles]');
      container.classList.remove('hidden');
      container.innerHTML = '';
      articles.forEach((article) => {
        const defaultState = article.dataset.handle == unfoldArticle ? 'block' : 'hidden';
        const articleElement = this.createArticle(article, defaultState);
        container.appendChild(articleElement);
      });
    }

    createArticle(article, defaultState = 'hidden') {
      const articleElement = document.createElement('div');
      const articleContent = document.createElement('div');
      const articleTitle = document.createElement('h3');
      articleElement.classList.add('py-4', 'cursor-pointer');
      articleContent.dataset.articleContent = '';
      articleTitle.classList.add('text-base', 'md:text-lg');
      articleTitle.innerHTML = article.dataset.title;
      articleTitle.dataset.handle = article.dataset.handle;
      articleContent.innerHTML = article.dataset.contentRaw;
      articleContent.classList.add(defaultState, 'pt-3', 'rte');
      articleElement.appendChild(articleTitle);
      articleElement.appendChild(articleContent);

      articleElement.addEventListener('click', () => {
        this.querySelectorAll('[data-article-content]').forEach((el) => {
          el.classList.add('hidden');
        });
        window.history.pushState('', '', `/blogs/${article.dataset.handle}`);
        articleContent.classList.remove('hidden');
      });
      return articleElement;
    }
  }
  customElements.define('blog-overview', BlogOverview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tiles"] && !window.DesignMode) return;
  try {
    
    class CollectionRecommendation extends HTMLElement {
        constructor() {
            super()
            this.tryFindRecommendation()
        }

        async tryFindRecommendation() {
            const recommendations = await this.fetchRecommendations()

            if (!recommendations) {
                this.showFallbackProduct()
                return
            }
            const recommendation_array = Array.from(recommendations)

            // Check every recommendation and return first recommendation that match the current collection
            const recommendation = recommendation_array.find((recommendation) => {
                const recommendation_collections = recommendation.dataset.collection.split(',')
                const isFromCollection = recommendation_collections.some((collection) => {
                    return collection === this.dataset.collection
                })
                return isFromCollection
            })
            if (!recommendation) {
                console.info('No recommendation found for fetch: ' + this.dataset.url)
                this.showFallbackProduct()
            } else {
                this.innerHTML = ''
                this.appendChild(recommendation)
            }
        }

        async fetchRecommendations() {
            const response = await fetch(this.dataset.url)
            const text = await response.text()
            const html = document.createElement('div')
            html.innerHTML = text
            const recommendations = html.querySelectorAll('[data-product-card]')
            return recommendations
        }

        showFallbackProduct() {
            this.querySelector('[data-spinner]').remove()
            this.querySelector('[data-fallback]').classList.remove('hidden')
        }
    }

    customElements.define('collection-recommendation', CollectionRecommendation)

  } catch(e) { console.error(e); }
})();
})();
